export const tooltip = {
  mounted(el, binding) {
    el._binding = binding;
    el.setAttribute("aria-label", binding.value?.title || "");
    el.dataset.tooltipId = Math.random().toString(16).slice(2);

    const onEnter = () => create(el);
    const onKeyup = () => create(el);
    const onLeave = () => remove(el);
    const onFocusOut = () => remove(el);
    const onClick = () => remove(el);

    el._tooltipHandlers = { onEnter, onKeyup, onLeave, onFocusOut, onClick };

    el.addEventListener("mouseenter", onEnter);
    el.addEventListener("keyup", onKeyup);
    el.addEventListener("mouseleave", onLeave);
    el.addEventListener("focusout", onFocusOut);
    el.addEventListener("click", onClick);
  },

  updated(el, binding) {
    el._binding = binding;
    el.setAttribute("aria-label", binding.value?.title || "");

    const tooltip = document.querySelector("#tooltip-" + el.dataset.tooltipId);
    if (tooltip) {
      const title = binding.value?.title || "";
      tooltip.textContent = title;
      tooltip.title = title;

      const tooltipContainer = document.getElementById("tooltip-container");
      const classes = tooltip.className || "";
      const position = classes.includes("left")
        ? "left"
        : classes.includes("right")
          ? "right"
          : classes.includes("bottom")
            ? "bottom"
            : "top";

      setTooltipContainerPosition(el, tooltipContainer, position);
    }
  },

  unmounted(el) {
    if (el._tooltipHandlers) {
      const handler = el._tooltipHandlers;
      el.removeEventListener("mouseenter", handler.onEnter);
      el.removeEventListener("keyup", handler.onKeyup);
      el.removeEventListener("mouseleave", handler.onLeave);
      el.removeEventListener("focusout", handler.onFocusOut);
      el.removeEventListener("click", handler.onClick);
      delete el._tooltipHandlers;
    }
    remove(el);
  },
};

function create(el) {
  const binding = el._binding || { value: {} };
  if (!binding.value || binding.value.hide) return;

  const tooltipId = el.dataset.tooltipId;
  let tooltipContainer = document.getElementById("tooltip-container");
  if (!tooltipContainer) {
    tooltipContainer = document.createElement("div");
    tooltipContainer.id = "tooltip-container";
    document.body.appendChild(tooltipContainer);
  }

  let tooltip = document.querySelector("#tooltip-" + tooltipId);
  let position = binding.value.position ? binding.value.position : "top";
  const wrap = binding.value.textWrap ? " wrap" : "";

  if (!tooltip) {
    tooltip = document.createElement("span");
    tooltip.id = "tooltip-" + tooltipId;
  }

  const title = binding.value.title || "";
  tooltip.title = title;
  tooltip.className = "tooltip-i fadeIn " + position + wrap;
  tooltip.textContent = title;

  if (title && tooltipContainer && !tooltip.parentNode) {
    tooltipContainer.appendChild(tooltip);
  }

  if (binding.value.textWrap) {
    if (title.length < 85) {
      tooltip.style.cssText = "width: fit-content";
    } else {
      tooltip.style.cssText = "width: 450px";
    }
  }

  const elRect = el.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  if (elRect.right + tooltipRect.width > window.innerWidth) {
    position = "left";
  } else if (elRect.left - tooltipRect.width < 0) {
    position = "right";
  } else if (elRect.top - tooltipRect.height < 0) {
    position = "bottom";
  } else if (elRect.bottom + tooltipRect.height > window.innerHeight) {
    position = "top";
  }

  tooltip.className = "tooltip-i fadeIn " + position + wrap;
  setTooltipContainerPosition(el, tooltipContainer, position);
}

function remove(el) {
  const tooltipContainer = document.getElementById("tooltip-container");
  if (tooltipContainer) {
    const tooltip = tooltipContainer.querySelector("#tooltip-" + el.dataset.tooltipId);
    if (tooltip) {
      tooltip.classList.remove("fadeIn");
      tooltip.classList.add("fadeOut");
      tooltipContainer.removeChild(tooltip);
    }
    clean(tooltipContainer);
  }
}

function clean(tooltipContainer) {
  const tooltips = tooltipContainer.querySelectorAll(".tooltip-i");
  for (let i = 0; i < tooltips.length; i++) {
    const trigger = document.querySelector("[data-tooltip-id='" + tooltips[i].id.split("-")[1] + "']");
    if (!trigger) {
      tooltipContainer.removeChild(tooltips[i]);
    }
  }
}
export function getSideIntersectingWith(entry) {
  if (entry.boundingClientRect.right !== entry.intersectionRect.right) {
    return "right";
  } else if (entry.boundingClientRect.left !== entry.intersectionRect.left) {
    return "left";
  } else if (entry.boundingClientRect.top !== entry.intersectionRect.top) {
    return "top";
  } else if (entry.boundingClientRect.bottom !== entry.intersectionRect.bottom) {
    return "bottom";
  }
}

function setTooltipContainerPosition(el, tooltipContainer, position) {
  if (el) {
    const elPosition = el.getBoundingClientRect();
    const bodyPosition = document.body.getBoundingClientRect();
    let top = elPosition.top - bodyPosition.top;

    if (position === "left" || position === "right") {
      top = top + elPosition.height / 2;
    } else if (position === "bottom") {
      top = top + elPosition.height;
    }

    if (tooltipContainer) {
      tooltipContainer.style.cssText = "top: " + top + "px;";
      tooltipContainer.style.cssText += "left: " + elPosition.left + "px;";
      tooltipContainer.style.cssText += "width: " + elPosition.width + "px;";
    }
  }
}
